module.exports = __webpack_public_path__ + "static/img/9.eb4701f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/msbl/9.jpg
// module id = +Ntm
// module chunks = 1